import { Box, Container } from "@mui/material";
import { FC } from "react";
import TitleBar from "../titleBar";
import Loader from "../loader/linearProgress";
import { styled } from "@mui/material/styles";

const TableWrapper = styled(Box)({
  width: "100%",
  border: "1px solid rgba(34, 51, 84, 0.1)",
  height: "100%",
  borderRadius: "5px",
  padding: "24px 0",
  marginBottom: "16px",
});

export const TableViewContainer: FC<{
  children: React.ReactNode;
  titleBar?: any;
  loading?: boolean;
  titleBarNodes?: React.ReactNode;
  filter?: boolean;
  editColumns?: boolean;
}> = ({ children, titleBar, loading = false }) => {
  return (
    <Container disableGutters>
      <TableWrapper>
          {titleBar && (
            <TitleBar
              title={titleBar?.title}
              subHeading={titleBar?.subHeading}
              rowCount={titleBar?.rowCount}
              buttonTitle={titleBar?.buttonTitle}
              titleBarNodes={titleBar?.titleBarNodes}
              onClick={titleBar?.onClick}
              disabled={titleBar.disabled}
              headerTitle={titleBar?.headerTitle}
              buttonLoading={titleBar?.buttonLoading}
              filter={titleBar?.filter}
              editColumns={titleBar?.editColumns}
            />
          )}
        {loading ? <Loader /> : children}
      </TableWrapper>
    </Container>
  );
};
